/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SystemSettingKey = {
    TranslationToolUrl: 'TranslationToolUrl',
    ViennaAddressLastImport: 'ViennaAddressLastImport',
    AmsSid: 'AmsSid',
    MailMergeDataSourceFolder: 'MailMergeDataSourceFolder',
    EdictReconciliationCutOffDate: 'EdictReconciliationCutOffDate'
} as const;
export type SystemSettingKey = typeof SystemSettingKey[keyof typeof SystemSettingKey];


export function instanceOfSystemSettingKey(value: any): boolean {
    for (const key in SystemSettingKey) {
        if (Object.prototype.hasOwnProperty.call(SystemSettingKey, key)) {
            if (SystemSettingKey[key as keyof typeof SystemSettingKey] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SystemSettingKeyFromJSON(json: any): SystemSettingKey {
    return SystemSettingKeyFromJSONTyped(json, false);
}

export function SystemSettingKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemSettingKey {
    return json as SystemSettingKey;
}

export function SystemSettingKeyToJSON(value?: SystemSettingKey | null): any {
    return value as any;
}

export function SystemSettingKeyToJSONTyped(value: any, ignoreDiscriminator: boolean): SystemSettingKey {
    return value as SystemSettingKey;
}

